import {api} from './requestGraphql'

const getNotifications = async (data) => {
  const { employeeId, dateRange = 'allPeriod' , email} = data;

  try {
    const res = await api.post(
      '', {
        query: `
                    {
                        getNotifications(employeeId: ${employeeId}, email:  """${email}""", dateRange:  """${dateRange}""") {
                            id
                            note
                            noteId
                            authorEmail
                            affiliateName
                            dateAdded
                            status
                        }
                    }
                `
      }
    )

    return res.data.data.getNotifications
  } catch (e) {
    console.error(e)
  }
}
const updateNotification = async (data) => {

  try {
    const res = await api.post(
      '', {
        query: `
                mutation {
                    updateNotification(
                        id:${data.noteId}
                        status:"""${data.status}"""                         
                    ){
                      id
                    }
                }
            `
      }
    )

    return res.data.data.updateNotification
  } catch (e) {
    console.error(e)
  }
}

export default {
  getNotifications,
  updateNotification
}